import { useQuery } from '@tanstack/react-query';
import { TSMSTemplate } from 'components/FlowBuilder/FlowSidePanels/types';
import smsService from 'services/api/sms.api';

type UseSMSTemplatesOptions = {
  enabled?: boolean;
};

const useSMSTemplates = (options: UseSMSTemplatesOptions = {}) => {
  const { enabled = true } = options;
  const { data, isLoading, isFetching, error, refetch } = useQuery<TSMSTemplate[], Error>({
    queryKey: ['sms-templates'],
    queryFn: () => smsService.getSMSTemplates(),
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return {
    smsTemplates: data || [],
    areSMSTemplatesLoading: isLoading,
    areSMSTemplatesFetching: isFetching,
    smsTemplatesError: error,
    refetchSMSTemplates: refetch,
  };
};

export default useSMSTemplates;
